// Launch promotion config. Set `active: false` to hide the banner everywhere.
export const promo = {
  active: true,
  code: "LAUNCH",
  message: "Launch week — 20% off the AI Writing Kit with code",
  ctaText: "Get it →",
  ctaTo: "/products/ai-writing-kit",
  storageKey: "vaymilo-promo-dismissed-v1", // bump to re-show after edits
};
